<template>
  <div class="p-grid" v-if="$ability.can('write', 'Farm')">
    <div class="p-col-12 p-md-4">
      <AppSkeletonCardForm v-if="loading" :rows="4" />
      <Card v-else>
        <template v-slot:title>Dados da Fazenda</template>
        <template v-slot:content>
          <AppForm
            ref="form"
            :rules="rules"
            :values="farm"
            v-slot:default="{ formErrors }"
          >
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                <AppFormItem :error="formErrors.name" label="Nome">
                  <InputText v-model="farm.name" />
                </AppFormItem>
              </div>
              <div class="p-field p-col-12">
                <AppFormItem label="Status">
                  <AutoComplete
                    :modelValue="{ name: farm.status ? 'Ativo' : 'Inativo' }"
                    @update:modelValue="(e) => (farm.status = e.value)"
                    :suggestions="statusOptions"
                    @complete="() => (statusOptions = [...statusOptions])"
                    field="name"
                    dropdown
                  ></AutoComplete>
                </AppFormItem>
              </div>
              <div class="p-field p-col-12">
                <AppFormItem label="Descrição">
                  <Textarea v-model="farm.description" rows="3" />
                </AppFormItem>
              </div>
            </div>
          </AppForm>
        </template>

        <template v-slot:footer>
          <div class="p-grid p-jc-end">
            <div style="padding-right: 8px">
              <router-link tag="span" :to="{ name: 'farm.list' }">
                <Button label="Cancelar" class="p-button-outlined p-mr-2" />
              </router-link>
              <AppButton
                label="Salvar"
                @click="save()"
                :loading="loadingSave"
              />
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div
      class="p-col-12 p-md-8"
      v-if="$route.params.id && $ability.can('read', 'Bovine')"
    >
      <FarmBovineCard :id="Number($route.params.id)" />
    </div>
    <div class="p-col-12" v-if="$route.params.id">
      <div class="p-grid p-jc-end p-mt-2">
        <router-link tag="span" :to="{ name: 'farm.list' }">
          <Button label="Voltar" class="p-button-outlined p-mr-2" />
        </router-link>
      </div>
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { FarmApi } from '../../services/api';
import FarmBovineCard from './components/FarmBovineCard';

export default {
  name: 'FarmEdit',

  components: {
    FarmBovineCard,
  },

  data() {
    return {
      statusOptions: [
        { name: 'Ativo', value: true },
        { name: 'Inativo', value: false },
      ],
      loading: false,
      loadingSave: false,
      farm: {
        name: '',
        description: '',
        status: true,
      },
      rules: {
        name: [{ required: true, message: 'Informe o nome.' }],
      },
    };
  },

  async created() {
    if (this.$route.params.id) {
      try {
        this.loading = true;
        this.farm = await FarmApi.fetchById(this.$route.params.id);
      } finally {
        this.loading = false;
      }
    }
  },

  methods: {
    async save() {
      try {
        if (!(await this.$refs.form.validate())) {
          return;
        }

        this.loadingSave = true;
        const body = { ...this.farm };
        console.log('body', JSON.stringify(body, null, 2));

        if (!this.$route.params.id) {
          await FarmApi.create(body);
        } else {
          await FarmApi.update(this.$route.params.id, body);
        }

        this.$router.push({ name: 'farm.list' });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingSave = false;
      }
    },
    handleError(error) {
      console.log(error);
      let detail = 'Não foi possível salvar a fazenda.';
      if (error.code === 'AlreadyExistError') {
        detail = 'Já existe uma fazenda com esse nome.';
      }
      if (error.code === 'PlanLimitExceededError') {
        detail = 'O limite de fazendas do seu plano foi atingido.';
      }
      this.$toast.add({
        severity: 'error',
        summary: 'Desculpe! Não é possível salvar.',
        detail,
        life: 3000,
      });
    },
  },
};
</script>

<style>
</style>